import { Component } from '@mycolorway/tao';
import moment from 'moment';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import 'next/stylesheets/components/list-project-preview';

Component('tr-list-project-preview-grid', {
  properties: {
    firstTodoName: String,
    secondTodoName: String,
    thirdTodoName: String,
    firstListName: String,
    secondListName: String,
    thirdListName: String,
    animojiAvatars: Array,
    firstTodoStartAndDueAt: Array,
    secondTodoStartAndDueAt: Array,
    thirdTodoStartAndDueAt: Array,
  },

  mixins: [eventListenerMixin],

  connected() {
    const [firstTodo, secondTodo, thirdTodo] = this.querySelectorAll('.list-project-preview-grid-row.todo-row');
    Object.assign(this, { firstTodo, secondTodo, thirdTodo });
    const [firstList, secondList, thirdList] = this.querySelectorAll('.list-project-preview-grid-row.section-row');
    Object.assign(this, { firstList, secondList, thirdList });
  },

  disconnected() {
    this.stopListening();
  },

  updateTodoName(todo, name, { create }) {
    const todoRow = this[todo];
    todoRow.querySelector('.list-project-preview-grid-todo-name').innerHTML = name;
    this[`${todo}Name`] = name;
    if (create && !todoRow.hasAttribute('created')) {
      this.todoInsertAssignee(todo);
      this.todoInsertDueAt(todo);
      this.todoInsertPriority(todo);
      this.todoInsertCreatedAt(todo);
      todoRow.setAttribute('created', true);
      console.log('create');
    }
  },

  todoInsertDueAt(todo) {
    const todoRow = this[todo];
    const formatDueAt = d => moment(d).format('MMMDo');
    const dueAt = [this.firstTodoStartAndDueAt.map(formatDueAt).join(' - '),
      this.secondTodoStartAndDueAt.map(formatDueAt).join(' - '),
      this.thirdTodoStartAndDueAt.map(formatDueAt).join(' - ')][this.todoSequence(todo)];
    todoRow.querySelector('.list-project-preview-grid-cell.due-at').innerHTML = `<div>${dueAt}</div>`;
  },

  todoInsertAssignee(todo) {
    const todoRow = this[todo];
    const assignee = this.animojiAvatars[this.todoSequence(todo)];
    todoRow.querySelector('.list-project-preview-grid-cell.assignee').innerHTML = `<img class="list-project-preview-grid-avatar" src="https://towerfiles.oss-cn-hangzhou.aliyuncs.com/animoji/${assignee}.png" alt="${assignee}">`;
  },

  todoInsertPriority(todo) {
    const todoRow = this[todo];
    const priority = ['high', 'medium', 'low'][this.todoSequence(todo)];
    todoRow.querySelector('.list-project-preview-grid-cell.priority').innerHTML = `<div class="list-project-preview-grid-priority-pill" priority="${priority}"></div>`;
  },

  todoInsertCreatedAt(todo) {
    const todoRow = this[todo];
    const createdAt = ['今天', '今天', '今天'][this.todoSequence(todo)];
    todoRow.querySelector('.list-project-preview-grid-cell.created-at').innerHTML = `<div>${createdAt}</div>`;
  },

  todoSequence(todo) {
    return {
      firstTodo: 0,
      secondTodo: 1,
      thirdTodo: 2,
    }[todo];
  },

  updateListName(list, name) {
    const listRow = this[list];
    listRow.querySelector('.list-project-preview-grid-section-name').innerHTML = name;
    if (name && name.length > 0) {
      listRow.classList.remove('hidden-row');
    } else if (!name || name.length === 0) {
      listRow.classList.add('hidden-row');
    }
  },
});
